/**
 * @typedef {Object} Deal
 * @property {number}  id
 * @property {string}  title
 * @property {string}  image
 * @property {number}  originalPrice
 * @property {number}  discountedPrice
 * @property {string}  category
 * @property {string}  platform
 * @property {string}  affiliateUrl
 * @property {boolean} trending
 */

/** @type {Deal[]} */
export const MAX_DISCOUNT = 87;
export const DEALS = [
  {
    id: 1,
    title: 'FUR JADEN Anti Theft Bag with 15.6 Inch Laptop Compartment, USB Charging Port & Organizer Pocket for Men Women Boys Girls',
    image: 'https://m.media-amazon.com/images/I/716eUpQQoHL._SX250_.jpg',
    originalPrice: 2000,
    discountedPrice: 449,
    category: 'Fashion',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4wACo8K',
    trending: true,
  },
  {
    id: 2,
    title: 'LEDO Mens and Womens Watch Box Holder Organizer Case In 12 Slots of watches',
    image: 'https://m.media-amazon.com/images/I/815s2tmyNkL._AC_UL320_.jpg',
    originalPrice: 3999,
    discountedPrice: 708,
    category: 'Fashion',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4nydNxh',
    trending: true,
  },
  {
    id: 3,
    title: 'Scotch-Brite Twin Bucket Spin Mop with Easy Wring & Rinse System',
    image: 'https://m.media-amazon.com/images/I/617-GkuimdL._SL1250_.jpg',
    originalPrice: 2200,
    discountedPrice: 1149,
    category: 'Home',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4wBpTJV',
    trending: false,
  },
  {
    id: 4,
    title: 'Fastrack Astor FR2 Pro 1.43" AMOLED Stainless Steel Smart Watch',
    image: 'https://m.media-amazon.com/images/I/412iPERxh+L._SY300_SX300_QL70_FMwebp_.jpg',
    originalPrice: 5499,
    discountedPrice: 2799,
    category: 'Electronics',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4wEZCuw',
    trending: false,
  },
  {
    id: 5,
    title: 'American Tourister Valex | 28L Backpack | 17" Laptop Bag |',
    image: 'https://m.media-amazon.com/images/I/51yfw2JIxwL._SL580_.jpg',
    originalPrice: 2500,
    discountedPrice: 949,
    category: 'Fashion',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/49V7QVk',
    trending: true,
  },
  {
    id: 6,
    title: "Philips India's No.1 Men's Trimmer | Single stroke beard trimming",
    image: 'https://m.media-amazon.com/images/I/61FfgEFs1iL._SL1500_.jpg',
    originalPrice: 2045,
    discountedPrice: 1399,
    category: 'Electronics',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/495Db7u',
    trending: false,
  },
  {
    id: 7,
    title: 'LOUIS DEVIN Rose Gold Plated Mesh Chain Analog Wrist Watch for Women',
    image: 'https://m.media-amazon.com/images/I/71R7AfsSLuL._AC_UY618_.jpg',
    originalPrice: 2599,
    discountedPrice: 341,
    category: 'Fashion',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4frVtDP',
    trending: true,
  },
  {
    id: 8,
    title: 'TIMEX Classics Analog Watch for Men with Round Dial & Water Resistant Mans Wrist Watches',
    image: 'https://m.media-amazon.com/images/I/71Kx6rgmlRS._SX279_.jpg',
    originalPrice: 1895,
    discountedPrice: 1044,
    category: 'Fashion',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4tKM5ij',
    trending: true,
  },
  {
    id: 9,
    title: 'GLUN Electronic Portable Digital LED Screen Luggage Weighing Scale',
    image: 'https://m.media-amazon.com/images/I/61Z35SZs7lL._SX522_.jpg',
    originalPrice: 899,
    discountedPrice: 235,
    category: 'Home',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4dwet1m',
    trending: true,
  },
  {
    id: 10,
    title: 'Set of 10 Board Books for Kids',
    image: 'https://m.media-amazon.com/images/I/61MmnHY2WuL._SL1000_.jpg',
    originalPrice: 699,
    discountedPrice: 369,
    category: 'Home',
    platform: 'Amazon',
    affiliateUrl: 'https://amzn.to/4dwet1m',
    trending: true,
  }
  
]

export default DEALS
